var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showType == 'svg')?_c('div',{domProps:{"innerHTML":_vm._s(_vm.QrSvg)}}):(_vm.showType == 'img')?_c('div',[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.QrSrc),expression:"QrSrc"}],attrs:{"src":_vm.QrSrc}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }